import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89660e4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "product-feedback-section"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Attune WC Access", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "This broker has access to Attune Work Comp! Ask them about their experience with the new product.", -1))
const _hoisted_5 = { class: "button-container" }
const _hoisted_6 = {
  key: 0,
  class: "error"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Feedback submitted!", -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CollapsibleSection = _resolveComponent("CollapsibleSection")!

  return (!_ctx.isSubmittedAndHidden)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_CollapsibleSection, {
          collapsed: _ctx.isCollapsed,
          onToggleCollapse: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggle()))
        }, {
          caption: _withCtx(() => [
            _hoisted_2
          ]),
          content: _withCtx(() => [
            (!_ctx.isSubmitted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _hoisted_4,
                    _withDirectives(_createElementVNode("textarea", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.comment = $event)),
                      placeholder: "Input feedback here...",
                      rows: "4"
                    }, null, 512), [
                      [_vModelText, _ctx.comment]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit())),
                      id: "submitButton"
                    }, "Submit")
                  ]),
                  (!!_ctx.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.error), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!!_ctx.isSubmitted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["collapsed"])
      ]))
    : _createCommentVNode("", true)
}